
import React from 'react';

import { useRemoveInspectionMutation } from 'generated/graphql';


export function useRemoveInspection() {
  const [
    fnMutate,
    tuple
  ] = useRemoveInspectionMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
